import React, { useState, useEffect, useRef, useMemo } from 'react';
import './Products.css';

const productsList = [
    { id: 1, name: 'DA Amlo-5', description: 'Amlodipine 5 mg', price: 'INR 28', image: '/products/da-amlo-5.png' },
    { id: 2, name: 'Metomaya-50', description: 'Metoprolol Succinate 50 mg (ER)', price: 'INR 65', image: '/products/metomaya-50.png' },
    { id: 3, name: 'Metomaya-25', description: 'Metoprolol Succinate 25 ER Tablet', price: 'INR 47', image: '/products/metomaya-25.png' },
    { id: 4, name: 'CliniPanj-10', description: 'Clinidipine 10mg', price: 'INR 80', image: '/products/clinipanj-10.png' },
    { id: 5, name: 'TelDA-40', description: 'Telmisartan 40 mg', price: 'INR 75.7', image: '/products/telda-40.png' },
    { id: 6, name: 'Telmet DA-40/25', description: 'Telmisartan 40 mg + Metoprolol 25 mg', price: 'INR 140', image: '/products/telmet-da-40-25.png' },
    { id: 7, name: 'TelMaya 50', description: 'Telmisartan 40 mg (Bilayer) + Metoprolol (ER) 50 mg', price: 'INR 105', image: '/products/telmaya-50.png' },

    { id: 8, name: 'Atorin DA-10/75', description: 'Atorvastatin Calcium 10 mg & Aspirin 75 mg', price: 'INR 59.6', image: '/products/atorin-da-10-75.png' },
    { id: 9, name: 'AtorvAro-40', description: 'Atorvastatin Calcium 40 mg', price: 'INR 213', image: '/products/atorvaro-40.png' },
    { id: 10, name: 'AtorvAro-20', description: 'Atorvastatin Calcium 20 mg', price: 'INR 120', image: '/products/atorvaro-20.png' },
    { id: 11, name: 'StarRose 10/75', description: 'Rosuvastatin 10 mg + Clopidogrel 75 mg', price: 'INR 150', image: '/products/starrose-10-75.png' },
    { id: 12, name: 'Atorinel DA 10', description: 'Atorvastatin 10 mg + Aspirin 75 mg + Clopidogrel 75 mg', price: 'INR 112', image: '/products/atorinel-da-10.png' },
    { id: 13, name: 'Atorinel DA 20', description: 'Atorvastatin 20 mg + Aspirin 75 mg + Clopidogrel 75 mg', price: 'INR 93.3', image: '/products/atorinel-da-20.png' },

    { id: 14, name: 'GlimeStars1', description: 'Metformin HCl 500 mg PR + Glimepiride 1 mg', price: 'INR 99', image: '/products/glimestars1.png' },
    { id: 15, name: 'GlimeStars2', description: 'Metformin HCl 500 mg PR + Glimepiride 2 mg', price: 'INR 121', image: '/products/glimestars2.png' },
    { id: 16, name: 'TenmetPanj-20', description: 'Teneligliptin 10 mg + Metformin 500 mg (ER)', price: 'INR 125', image: '/products/tenmetpanj-20.png' },
    { id: 17, name: 'VimetPanj-50', description: 'Vildagliptin 50 mg + Metformin 500 mg (SR)', price: 'INR 145', image: '/products/vimetpanj-50.png' },
    { id: 18, name: 'LiaStars-M1', description: 'Linagliptin 2.5 mg + Metformin 500 mg', price: 'INR 108', image: '/products/liastars-m1.png' },
    { id: 19, name: 'LinaStars-5', description: 'Linagliptin 5 mg', price: 'INR 126', image: '/products/linastars-5.png' },
    { id: 20, name: 'VoglStars-V2', description: 'Voglibose 0.2 mg', price: 'INR 50', image: '/products/voglsrars-v2.png' },
    { id: 21, name: 'VoglStars-V3', description: 'Voglibose 0.3 mg', price: 'INR 98', image: '/products/voglsrars-v3.png' },

    { id: 22, name: 'AziStars-500', description: 'Azithromycin 500 mg', price: 'INR 79', image: '/products/azistars-500.png' },
    { id: 23, name: 'APStars', description: 'Aceclofenac 100 mg + Paracetamol 325 mg + Serratiopeptidase 15 mg', price: 'INR 118', image: '/products/apstars.png' },
    { id: 24, name: 'MontiDA-10', description: 'Levocetirizine 5 mg + Montelukast 10 mg', price: 'INR 110', image: '/products/montida-10.png' },
    { id: 25, name: 'APStars-100', description: 'Aceclofenac 100 mg + Paracetamol 325 mg', price: 'INR 59', image: '/products/apstars-100.png' },
    { id: 26, name: 'PanDomStars-40', description: 'Pantoprazole 40 mg + Domperidone SR 30 mg', price: 'INR 139', image: '/products/pandomstars-40.png' },
];



const Products = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const searchRef = useRef(null);

    const products = useMemo(() => productsList, []);

    useEffect(() => {
        setFilteredProducts(products);
    }, [products]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setShowSuggestions(true);

        if (value.trim() === '') {
            setFilteredProducts(products);
            setSuggestions([]);
            return;
        }

        const searchResults = products.filter(product =>
            product.name.toLowerCase().includes(value.toLowerCase()) ||
            product.description.toLowerCase().includes(value.toLowerCase())
        );

        const suggestionResults = products
            .filter(product =>
                product.name.toLowerCase().includes(value.toLowerCase())
            )
            .map(product => product.name)
            .slice(0, 5);

        setFilteredProducts(searchResults);
        setSuggestions(suggestionResults);
    };

    const handleSuggestionClick = (suggestion) => {
        setSearchTerm(suggestion);
        setShowSuggestions(false);
        const searchResults = products.filter(product =>
            product.name.toLowerCase().includes(suggestion.toLowerCase())
        );
        setFilteredProducts(searchResults);
    };

    const handleEnquiry = (productName) => {
        const message = `I would like to enquire about ${productName}`;
        window.open(`https://wa.me/8237434068?text=${encodeURIComponent(message)}`);
    };

    return (
        <div className="products-container">
            <div className="products-header">
                <h2>Our Products</h2>
                <p>Discover our range of pharmaceutical solutions</p>
                <div className="search-container" ref={searchRef}>
                    <div className="search-input-wrapper">
                        <input
                            type="text"
                            placeholder="Search products..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="search-input"
                        />
                        <i className="fas fa-search search-icon"></i>
                    </div>
                    {showSuggestions && suggestions.length > 0 && (
                        <ul className="suggestions-list">
                            {suggestions.map((suggestion, index) => (
                                <li
                                    key={index}
                                    onClick={() => handleSuggestionClick(suggestion)}
                                >
                                    {suggestion}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
            <div className="product-grid">
                {filteredProducts.map((product) => (
                    <div key={product.id} className="product-card">
                        <div className="product-image">
                            <img src={product.image} alt={product.name} />
                        </div>
                        <div className="product-details">
                            <h3>{product.name}</h3>
                            <p>{product.description}</p>
                            <button 
                                onClick={() => handleEnquiry(product.name)}
                                className="enquire-button"
                            >
                                <i className="fab fa-whatsapp"></i> Enquire Now
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Products;
